export enum FilterOperatorType {
  Contains = "grid.filterContainsOperator",
  NotContains = "grid.filterNotContainsOperator",
  Equal = "grid.filterEqOperator",
  NotEqual = "grid.filterNotEqOperator",
  StartsWith = "grid.filterStartsWithOperator",
  EndsWith = "grid.filterEndsWithOperator",
  GreaterThanOrEqual = "grid.filterGteOperator",
  GreaterThan = "grid.filterGtOperator",
  LessThanOrEqual = "grid.filterLteOperator",
  LessThan = "grid.filterLtOperator",
  AfterOrEqual = "grid.filterAfterOrEqualOperator",
  After = "grid.filterAfterOperator",
  Before = "grid.filterBeforeOperator",
  BeforeOrEqual = "grid.filterBeforeOrEqualOperator",
  IsNull = "grid.filterIsNullOperator",
  IsNotNull = "grid.filterIsNotNullOperator",
}
